import './Footer.css'

function Footer () {
    return (
        <footer className="footer common-padding">
            <div className="footer-section">
                <img src={`${process.env.PUBLIC_URL}/Logo.png`} alt="Logo" className="footer-logo" />
                <p>Collaboration platform for modern teams.</p>
            </div>
            <div className="footer-section">
                <h4>Company</h4>
                <ul>
                    <li>About Us</li>
                    <li>Careers</li>
                    <li>Support</li>
                    <li>Knowledgebase</li>
                </ul>
            </div>
            <div className="footer-section">
                <h4>Features</h4>
                <ul>
                    <li>Screen Sharing</li>
                    <li>iOS & Android Apps</li>
                    <li>File Sharing</li>
                    <li>User Management</li>
                </ul>
            </div>
            <div className="footer-section">
                <h4>Contact Us</h4>
                <ul>
                    <li>info@teamapp.com</li>
                    <li>1-800-200-300</li>
                    <li>1010 Sunset Blvd, Palo Alto, California</li>
                </ul>
            </div>
            <div className="footer-section form-section">
                <h4>Stay up to date</h4>
                <form>
                    <input type="email" placeholder="Email" />
                    <button type="submit">
                        <img src={`${process.env.PUBLIC_URL}/arrow_right.png`} alt="Arrow" />
                    </button>
                </form>
            </div>
        </footer>
    )
}

export default Footer